import React, { Component } from 'react';
import ButtonRow from '../../../Elements/ButtonRow';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import SurveyService from '../../../Services/surveyService';
import ProjectSurveyItem from '../../../Domain/ProjectSurveyItem';
import ErrorMessage from '../../../Elements/ErrorMessage';
import AssociateSurveyPanel from '../../Sales/ClientAdmin/SurveyAdmin/AssociateSurveyPanel';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';

class ProjectSurveyAdmin extends Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      loading: true,
      selected: -1,
      NumberofElementConst: 10,
      numberOfElementInList: 10,
      shownPanel: null,
      selectedItem: null,
      showAll: false,
      searchItem: { Id: this.props.searchItem.CfId },
    };
    this.showPanel = this.showPanel.bind(this);
    ProjectSurveyItem.removeFunction = this.clickOnRemoveSurvey.bind(this);
  }

  clickOnRemove(selectedItem) {
    const tempObj = {
      Id: selectedItem.ProjectId,
      EntityId: selectedItem.SurveyId,
      SassieId: selectedItem.SassieId,
    };
    ErrorMessage.SetNotification(
      'The survey deletion process started in the background. This might take some time, you will be notified via in-app notification when the process has finished.'
    );

    SurveyService.RemoveProjectSurvey(tempObj)
      .then((response) => {
        if (response && response.error) {
          ErrorMessage.SetErrorMessage(response.error);
        } else {
          ErrorMessage.SetNotification(
            `Survey #${selectedItem.SassieId} successfully removed from ${selectedItem.ProjectId}.`
          );
        }
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: PSA79. Survey remove failed. Please notify IT!');
      });

    this.simulateEscapeKeydown();
  }

  clickOnEditFunction(clickOnEselectedId, selectedItem) {
    this.setState({
      selected: selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
    this.setState({ shownPanel: ShownPanelsEnum.EditItem });
  }

  clickOnRemoveSurvey(selectedItem, selectedId) {
    ErrorMessage.SetApprove('You are about to remove this survey.', () => this.clickOnRemove(selectedItem));
    this.setState({ selected: selectedItem });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.ShowAll) {
      this.setState({ showAll: !this.state.showAll });
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderPanels() {
    if (
      this.props.IsActive === false &&
      (this.state.shownPanel === ShownPanelsEnum.AddNewItem || this.state.shownPanel === ShownPanelsEnum.EditItem)
    ) {
      return (
        <div
          className='alert alert-danger'
          role='alert'
        >
          Client is Inactive!
        </div>
      );
    }

    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <AssociateSurveyPanel
            clickOnCancel={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            searchItem={this.props.searchItem}
            isOverWindow={true}
          />
        )}
      </div>
    );
  }

  AreAllItemsSelected() {
    return this.state.numberOfElementInList === this.state.NumberofElementConst;
  }

  renderActionButtonRow() {
    return (
      <ButtonRow
        tooltips={['Associate', this.state.showAll ? `Show last ${this.state.NumberofElementConst}` : 'Show All']}
        keys={[ShownPanelsEnum.AddNewItem, ShownPanelsEnum.ShowAll]}
        roleKeys={['project_associatesurvey']}
        icons={['fa-solid fa-plus-circle', this.state.showAll ? 'fa-regular fa-user' : 'fa-solid fa-users']}
        value={this.state.shownPanel}
        onClick={this.showPanel}
        className='InnerMenuButtonFigmaList'
        colors={[ButtonColorsEnum.Primary, ButtonColorsEnum.Secondary]}
      />
    );
  }

  simulateEscapeKeydown() {
    // M: Simulates an Escape keydown event, so the opened project details window is closed after removing a survey.
    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        altKey: false,
        code: 'Escape',
        ctrlKey: false,
        isComposing: false,
        key: 'Escape',
        location: 0,
        metaKey: false,
        repeat: false,
        shiftKey: false,
        which: 27,
        charCode: 0,
        keyCode: 27,
      })
    );
  }

  render() {
    return (
      <div>
        {this.renderActionButtonRow()}
        {this.renderPanels()}
        <TabOfDataTable
          maxShownItem={this.state.showAll ? undefined : this.state.NumberofElementConst}
          type={ProjectSurveyItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={SurveyService.GetProjectSurveyList}
          convertDBItemsFunction={SurveyService.ConvertProjectSurveyDBItem}
          searchItem={this.state.searchItem}
          orderBy='Id'
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={false}
          clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
          numberOfElementsOnAPage={10000}
          errorCode='PSA181'
        />
      </div>
    );
  }
}

export default ProjectSurveyAdmin;
